import subTeamsStoreMutations from '@/state/subTeamsStore/subTeamsStoreMutations'
import subTeamStoreActions from '@/state/subTeamsStore/subTeamsStoreActions'
import getsubTeamsStoreDefaultState from '@/state/subTeamsStore/subTeamsStoreDefaultState'

let state = getsubTeamsStoreDefaultState()

export const subTeamsStore = {
  namespaced: true,
  state,
  mutations: subTeamsStoreMutations,
  actions: subTeamStoreActions
}
